<template>
  <div id="content">
    <form action="#">
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>

        <h1 v-translate>Přidat konfiguraci bootování</h1>
      </div>

      <div class="responsiveTabs">
        <device-boot-config-form
            :entity="entity"
            :operator-options="operatorOptions"
            :isEditable="$_createActionAllowed"
            @saveEntity="createEntity"
        />
      </div>
    </form>
  </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"
import DeviceBootConfigForm from "./forms/DeviceBootConfigForm.vue";

export default {
  name: 'DeviceBootConfigNew',
  components: { DeviceBootConfigForm },
  mixins: [detailActions],
  created(DeviceBootConfigService, OperatorService) {
    this.entityService = DeviceBootConfigService;
    this.operatorService = OperatorService
    this.getOperators(true, true)

    if(this.$route.params.idDevice) {
      this.entity.id_device = this.$route.params.idDevice;
    }
    if(this.$route.params.deviceName) {
      this.entity.device_name = this.$route.params.deviceName;
    }

    if(this.entity.is_theme === undefined) {
      // default true
      this.entity.is_theme = true;
    }
  },
  data() {
    return {
      moduleName: 'deviceBootConfigs',
      detailPageRouteName: 'deviceBootConfigDetail',
      updateFields: [
        'name',
        'image_url',
        'image_version',
        'splash_url',
        'splash_version',
        'is_theme',
        'id_operator',
        'id_device',
      ]
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceBootConfigs/DeviceBootConfigNew.vue